import styled from 'styled-components';

export const DateVar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background: transparent;
  padding-block: 5px;
  font-size: 13px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .edit-button {
    background: rgb(37,41 ,45);
    color: #fff;
    height: 90%;
    padding-inline: 5px;
    place-content: center;
    border-radius: 2px;
  }
`;